import {DomainAncestor, entityConfig} from "../../../core/common/domain/DomainAncestor";
import {observable} from "mobx";
import {RoomType} from "./roomTypeDomain";
import {ID} from "../../../core/metamodel/metaConstant";
import {LovItem} from "../../../core/metamodel/mdEntity";

@entityConfig()
export class ProjectVersionRoom extends DomainAncestor {

  @observable roomId : number;
  @observable roomNumber: string;
  @observable roomName : string;
  @observable area : number;
  @observable roomType : LovItem;
  @observable roomCategory: LovItem;
  @observable radonExposureLevel : LovItem<RADONEXPOSURELEVEL>;
  @observable projectVersion : LovItem;

  constructor(json: any) {
    super(json);
  }

  public getId(): ID {
    return this.roomId;
  }

  public setId(id: ID): void {
    this.roomId = <number>id;
  }

}

export enum RADONEXPOSURELEVEL {
  CONTACT_FLOOR = "CONTACT_FLOOR",
  FLOOR_NEXT_TO_CONTACT = "FLOOR_NEXT_TO_CONTACT",
  UPPER_FLOOR = "UPPER_FLOOR"
}



// WEBPACK FOOTER //
// ./src/sbtool/domain/project/projectVersionRoomDomain.ts